import type { AxiosResponse } from 'axios'

/**
 * Save an axios blob response as a file, honouring the server's filename.
 *
 * The server names the file (it knows the document or collection title and
 * encodes it per RFC 5987); the fallback only applies if the header is
 * missing entirely.
 */
export function saveResponseAsFile(res: AxiosResponse<Blob>, fallback: string): void {
  const disposition = String(res.headers['content-disposition'] ?? '')
  const utf8 = /filename\*=UTF-8''([^;]+)/i.exec(disposition)?.[1]
  const plain = /filename="([^"]+)"/i.exec(disposition)?.[1]
  const filename = utf8 ? decodeURIComponent(utf8) : (plain ?? fallback)

  const url = URL.createObjectURL(res.data)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  // Revoking immediately can cancel the download in some browsers; one tick is
  // enough for the navigation to have been picked up.
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}
